import React from "react";
import FilterHeader from "../../components/FilterHeader";
import FilterFixtures from "../../components/FilterFixtures";

const Fixtures = () => {
  return (
    <>
      <FilterHeader />
      <FilterFixtures />
    </>
  );
};

export default Fixtures;
